import {
  RatePlanFilter,
  ExactRoom,
  OccupancyRoom,
} from '@stencil/hotels-types/src/details-cg/types/searchRoom';

type RoomPlan = ExactRoom | OccupancyRoom;

interface GetCgFilteredRoomsParams<T extends RoomPlan> {
  currentFilters?: RatePlanFilter[];
  roomsDataFromCg?: T[];
  comboDataFromCg?: T[];
}

const getCgFilteredRooms = <T extends RoomPlan>({
  currentFilters = [] as RatePlanFilter[],
  roomsDataFromCg = [] as T[],
  comboDataFromCg = [] as T[],
}: GetCgFilteredRoomsParams<T>): T[] => {
  if (!currentFilters.length) {
    return !!comboDataFromCg?.length ? comboDataFromCg : roomsDataFromCg;
  }

  let filteredRoomData: T[] = [];

  const getFilteredRatePlans = (ratePlansData = [], filterData) => {
    const filteredRatePlans = ratePlansData?.filter(ratePlanData =>
      ratePlanData?.filterCode.includes(
        filterData?.code || filterData?.ratePlanFilterList?.[0]?.code,
      ),
    );
    return filteredRatePlans;
  };

  currentFilters.forEach(filterData => {
    roomsDataFromCg.forEach(roomData => {
      const filteredExactRoomRatePlans = getFilteredRatePlans(roomData?.ratePlans, filterData);
      if (filteredExactRoomRatePlans?.length) {
        filteredRoomData.push({...roomData, ratePlans: filteredExactRoomRatePlans});
      }
    });

    if (!!comboDataFromCg?.length) {
      let isComboDataFiltered = false;
      comboDataFromCg.forEach(roomData => {
        roomData?.rooms?.forEach(rd => {
          const filteredRatePlanData = getFilteredRatePlans(rd?.ratePlans, filterData);
          isComboDataFiltered = !!filteredRatePlanData?.length;
        });
        if (isComboDataFiltered) {
          filteredRoomData.push(roomData);
        }
      });
    }
  });

  const key = 'roomCode';

  const arrayUniqueByKey = [...new Map(filteredRoomData.map(item => [item[key], item])).values()];

  return arrayUniqueByKey;
};

export default getCgFilteredRooms;
